/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2018, 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class SavedPromptsAPI
 * @hideconstructor
 * @classdesc implementation of the SavedPromptsAPI interface
 */
define([], () => {
	/** Class representing a SavedPrompts API */
	class SavedPromptsAPI {

		/**
		 * @function SavedPromptsAPI#save
		 * @description Add or update a prompt spec saved to widget.
		 * @public
		 *
		 * @param {PromptValueSpec} promptValueSpec - promptValue specification object
		 */
		save(/* promptValueSpec */) { }

		/**
		 * @function SavedPromptsAPI#reset
		 * @description Clean saved prompt cache and reset to new promptValueSpecs.
		 * @public
		 *
		 * @param {Object} promptValueSpecs - Object with the keys corresponding to the prompt names and values with {@link PromptValueSpec}
		 * @example
		 * {
		 *	'multiPrompt': {
		 *	 'name': 'multiPrompt',
		 *		'capabilities': {
		 *			'unboundedRange': false,
		 *			'multivalued': true,
		 *			'boundRange': false,
		 *	'optional': false,
		 *			'discreteValue': true
		 *		},
		 *		'dataType': 'xsdString',
		 *		'values': [{
		 *			'value': '[source].[Product line]->[Golf Equipment]',
		 *			'label': 'Golf Equipment'
		 *		}, {
		 *			'value': '[source].[Product line]->[Mountaineering Equipment]',
		 *			'label': 'Mountaineering Equipment'
		 *		}],
		 *		'modelFilterItem': '[source].[Product line]'
		 *	},
		 *	'valueRangePrompt': {
		 *		'name': 'valueRangePrompt',
		 *		'capabilities': {
		 *			'unboundedRange': true,
		 *			'multivalued': true,
		 *			'boundRange': false,
		 *			'optional': false,
		 *			'discreteValue': false
		 *		},
		 *		'dataType': 'xsdInt',
		 *		'values': [{
		 *			'value': 7643,
		 *			'label': 7643
		 *		}, {
		 *			'value': 18294,
		 *			'label': 18294
		 *		}],
		 *		'modelFilterItem': '[Sales and marketing data].[QUANTITY]'
		 *	}
		 *
		 */
		reset(/* promptValueSpecs */) {}

		/**
		 * @function SavedPromptsAPI#getPromptSpec
		 * @description Get a saved prompt spec
		 * @public
		 *
		 * @param {String} promptName Name of the prompt definition
		 */
		getPromptSpec() {}

		/**
		 * @function SavedPromptsAPI#getPromptSpecList
		 * @description Get a list of promptValueSpec of the widget.
		 * @public
		 *
		 * @returns {PromptValueSpec[]} an array of PromptValueSpec of the widget.
		 */
		getPromptSpecList() {}

	}

	return SavedPromptsAPI;
});
